// constants.ts
export const STORAGE_KEYS = {
    INTERVIEW_RESPONSE: 'interview_response',
    CHAT_MESSAGES: 'chat_messages',
    CODING_DATA: 'coding_data',
    // Stores { slug, entries: SkippedCodingQuestion[] } — one entry per
    // skipped coding question, keyed to the current interview slug so
    // stale data from a different interview is ignored.
    SKIPPED_CODING_QUESTIONS: 'skipped_coding_questions',
    // VA-27633: { slug, startedAt } written once the candidate is in the
    // meeting. `screen` was never persisted, so ANY reload — including one the
    // candidate does because the interview looks stuck — dropped them back into
    // setup → guidelines → screen-share. The resume itself always worked; it was
    // just slow, alarming and undiscoverable.
    INTERVIEW_IN_PROGRESS: 'interview_in_progress',
};
